import ProductSlider from "./modules/ProductSlider";
import ProductFilter from "./modules/ProductFilter";
import ProductGallery from "./modules/ProductGallery";
import Truncate from "./modules/Truncate";

jQuery(function(){
    ProductSlider.bind();
    ProductGallery.bind();
    ProductFilter.bind();
    Truncate.bind();
});
